export const env = {
  REACT_APP_PASSWORD_MASK_SECRET: process.env.REACT_APP_PASSWORD_MASK_SECRET,
}
let studentId = ''
export const dummyJson = {
  student: {
    id: studentId,
    autoIncrementId: 25796,
    prefixId: 'S25796',
    createdAt: '2024-02-14T07:30:05.063Z',
    updateAt: '2024-02-15T05:35:11.076Z',
    profileUrl:
      'https://d18zc7o1u7b8o7.cloudfront.net/1707969444711-abhinesh_profile.png',
    firstName: 'ABHI',
    middelName: '',
    lastName: 'S',
    uniRollNo: '900',
    status: 1,
    prevStatus: 0,
    passedOut: false,
    profileCompletionPerc: 60,
    deletedAt: null,
    notIntrestedReason: null,
    notIntrestedDes: null,
    instituteCampusId: '',
    instituteCampusName: 'KING INSTITUTE OF PREVENTIVE MEDICINE & RESEARCH',
    courseId: '',
    currentState: 2,
    university: null,
    isExpCandidate: false,
    universityId: null,
    workExperience: 0,
    isReCalcRequired: false,
    rankRecalcDate: null,
  },
  studentPersonalProfile: {
    id: '60026aed-82ed-47d2-a219-17637becd4f2',
    createdAt: '2024-02-14T07:30:05.063Z',
    updateAt: '2024-02-15T04:00:19.049Z',
    dob: '2024-02-14',
    gender: 'MALE',
    caste: '',
    father: '',
    mother: '',
    religion: '',
    idProof: [],
    addressProof: [],
    secondaryEmail: 'abhinesh.s+6s@icanio.com',
    phoneNumber: '+91 9003717978',
    preferredJobLocation: [],
    languages: [],
    hobbies: [],
    socialMedia: [],
    permAddrLine1: 'TVL',
    permAddrLine2: 'TVLL',
    permCity: 'Chennai',
    permCityId: '',
    permState: 'Tamil Nadu',
    permStateId: '',
    permCountry: 'India',
    permCountryId: '',
    permPostCode: 284938,
    isSameCorresponding: true,
    corrAddrLine1: 'TVL',
    corrAddrLine2: 'TVLL',
    corrCity: 'Tuty',
    corrCityId: '',
    corrState: 'Tamil Nadu',
    corrStateId: '',
    corrCountry: 'India',
    corrCountryId: '',
    corrPostCode: 284938,
    isPhysicallyChallenged: false,
    physicalChallenge: '',
    studentId: studentId,
    isAnywhere: false,
    primaryEmail: 'abhinesh.s+6s@icanio.com',
  },
  resume: {
    id: '',
    createdAt: '2024-02-14T07:30:05.063Z',
    updateAt: '2024-02-15T17:18:03.052Z',
    objective: '',
    projects: [
      {
        id: '',
        role: 'Health Technologist ',
        title: 'Sa4r',
        awards: [],
        ended_in: '01/2024',
        function: 'Strategic ',
        industry: 'Exchange and Data Platform',
        skill_set: [
          {
            id: '',
            name: 'Roche 454 Life Sciences Gs Data Analysis',
          },
          {
            id: '',
            name: 'Sentryone Sql Sentry',
          },
        ],
        started_in: '03/2023',
        corporateId: '',
        description: '<p>yes all done</p>',
        organization: 'KAVITHA PLYWOODS LIMITED   ',
      },
    ],
    internships: [
      {
        id: '',
        role: 'C',
        awards: [],
        ended_in: '01/2022',
        function: 'Stratesgic management',
        industry: 'Other Telecom ',
        skill_set: [
          {
            id: '',
            name: 'RobotWare DieCast',
          },
          {
            id: '',
            name: 'sentai Pinpoint',
          },
        ],
        started_in: '01/2022',
        corporateId: '',
        description: 'hi all',
        organization: 'G.T. CONSULTATS PRIVATE LIMITED   ',
      },
    ],
    courses: [
      {
        id: '9f799fcc-973f-4784-b257-cba27bfa9378',
        title: '9000',
        awards: [],
        ended_in: '01/2024',
        skill_set: [
          {
            id: '1c2553e6-c870-4b1c-b45f-e304dd10bb60',
            name: 'sentai Pinpoint',
          },
          {
            id: 'b4b84ded-08ab-4d87-9c00-57e7b4fdba54',
            name: 'Roche 454 Life Sciences GS Data Analysis',
          },
        ],
        started_in: '01/2022',
        description: '<p>hi ll</p>',
        organization: 'hihih',
      },
    ],
    training: [],
    awards: [],
    workExperience: [
      {
        id: '',
        role: 'Health Technologist',
        title: 'jii',
        awards: [],
        jobType: 'FULL_TIME',
        ended_in: '04/2023',
        function: 'Strategic management',
        industry: 'Exchange and Data Platform',
        skill_set: [
          {
            id: '',
            name: 'RobotWare DieCast',
          },
        ],
        started_in: '03/2021',
        corporateId: '',
        description: '<p>hihih</p>',
        organization: 'KAVITHA PLYWOODS LIMITED   ',
        employee_type: '',
        work_location: '',
        isCurrentlyWorking: false,
        significant_outcome: '',
      },
    ],
    studentId: studentId,
  },
  education: [
    {
      id: '0a2cd274-88c4-4839-806a-5e14b1d7c272',
      createdAt: '2024-02-15T04:00:19.072Z',
      updateAt: '2024-02-15T04:00:19.072Z',
      educationLevel: 'tenth',
      institutionName: 'Servite',
      board: 'SSC (State board/Matriculation)',
      degree: null,
      department: null,
      specialisation: null,
      specialisationId: null,
      degreeStreamMapId: null,
      skills: null,
      registrationNo: null,
      startedOn: '',
      endedOn: '01/2022',
      marks: '90',
      city: 'Chennai',
      cityId: '',
      state: 'Tamil Nadu',
      stateId: '',
      country: null,
      countryId: null,
      tcUrl: {},
      markSheetUrl: {},
      studentId: studentId,
      awards: [],
      university: '',
      institutionId: null,
      universityId: null,
    },
    {
      id: 'c0de7cd5-fdf0-4d62-b9f2-b8e9fc33f70d',
      createdAt: '2024-02-15T04:00:19.086Z',
      updateAt: '2024-02-15T04:00:19.086Z',
      educationLevel: 'twelfth',
      institutionName: 'angelo',
      board: '',
      degree: null,
      department: null,
      specialisation: null,
      specialisationId: null,
      degreeStreamMapId: null,
      skills: [
        {
          id: '',
          name: 'Robotware Diecast',
        },
        {
          id: '',
          name: 'Roche 454 Life Sciences Gs Data Analysis',
        },
      ],
      registrationNo: null,
      startedOn: '',
      endedOn: '01/2024',
      marks: '80',
      city: 'Chennai',
      cityId: '',
      state: 'Tamil Nadu',
      stateId: '',
      country: null,
      countryId: null,
      tcUrl: {},
      markSheetUrl: {},
      studentId: studentId,
      awards: [],
      university: '',
      institutionId: null,
      universityId: null,
    },
    {
      id: '',
      city: '',
      isCv: true,
      board: '',
      marks: 0,
      state: '',
      tcUrl: {
        url: '',
        date: 0,
        name: '',
        size: '',
      },
      awards: [
        {
          title: '',
          awarded_on: '',
          certificate: {
            url: '',
            date: 0,
            name: '',
            size: '',
          },
          description: '',
        },
      ],
      cityId: '',
      degree: 'Bachelor of Technology',
      skills: [
        {
          id: '',
          name: 'Python',
        },
        {
          id: '',
          name: 'C',
        },
        {
          id: '',
          name: 'C++',
        },
        {
          id: '',
          name: 'SQL',
        },
        {
          id: '',
          name: 'HTML5',
        },
        {
          id: '',
          name: 'CSS3',
        },
        {
          id: '',
          name: 'Javascript',
        },
        {
          id: '',
          name: 'PHP',
        },
      ],
      country: '',
      endedOn: '2024',
      stateId: '',
      countryId: '',
      startedOn: '02/2020',
      department: 'Computer Science & Technology',
      university:
        'Charotar University of Science and Technology, Nadiad, Gujarat, India',
      universityId: '',
      institutionId: '',
      educationLevel: 'ug',
      specialisation: 'add',
      institutionName:
        'Charotar University of Science and Technology, Nadiad, Gujarat, India',
      degreeStreamMapId: '',
    },
  ],
  currentCourse: {
    id: '77e21d49-9508-48fb-9d43-04c490981e76',
    createdAt: '2024-02-14T07:30:05.063Z',
    updateAt: '2024-02-15T04:00:19.049Z',
    educationLevel: 'ug',
    admissionType: 'regular',
    previousCollege: '',
    previousUniversity: '',
    degree: 'Doctor Of Naturopathic Medicine',
    department: 'Electronics Engineering',
    degreeStreamMapId: '4cd27568-38fe-4f42-a31e-4c2a3868aafb',
    examType: '',
    duration: 0,
    specialisation: 'Cyber Physical Systems',
    specialisationId: '4015c5e8-b46f-4877-83bf-91a42ef50b19',
    skills: [
      {
        id: '4d8acdcc-7b37-4cc6-8ed5-72fb0df6c1e5',
        name: 'Robotic Workstation Software',
      },
      {
        id: 'e7021bcc-4486-4613-9177-32d960235035',
        name: 'Robotware Diecast',
      },
    ],
    startedOn: '1577817000000',
    endedOn: '1930069800000',
    city: 'Chennai',
    cityId: '6364edafe0338a14ae7356b8',
    state: 'Tamil Nadu',
    stateId: '6364edaee0338a14ae735176',
    country: '',
    countryId: '',
    cumulativeType: 'Percentage',
    marks: null,
    averageMarks: '90',
    noOfArrears: 0,
    attendanceBacklisted: false,
    conductBacklisted: false,
    collegeFeeBacklisted: false,
    studentId: studentId,
    awards: [],
    university: '9732e219-e797-4048-a19b-dd4c8321d097',
    universityId: '9732e219-e797-4048-a19b-dd4c8321d097',
    otherDegreeId: null,
    otherSpecialisationId: null,
    otherStreamId: null,
    streamId: '3d2c8ce9-6813-47da-b4bb-203f1cfde667',
    degreeId: '69c5559d-3145-4c1e-8107-1b6d2625a745',
  },
  admin: {
    _id: '65cc6bfd0f838bf679875c4c',
    corporate_id: null,
    institute_id: null,
    student_id: studentId,
    institute_campus_id: '',
    pluginlive_id: null,
    admin_role_id: 'ba3eb8cb-7edd-4ca2-875a-3a5092e39c91',
    email: 'abhinesh.s+6s@icanio.com',
    phone_number: '9003717978',
    country_code: '+91',
    first_name: 'ABHI',
    last_name: 'S',
    is_email_verified: true,
    is_active: true,
    deleted_at: null,
    created_at: '2024-02-14T07:30:05.101Z',
    updated_at: '2024-02-15T04:00:19.142Z',
    __v: 0,
    dob: '2024-02-14',
    gender: 'MALE',
  },
  profilePerCount: {
    profileCompleteRate: 60,
    mandetoryRate: 86,
  },
}

const tabValues = [
  { label: 'Placement', value: 'PLACEMENT' },
  { label: 'Internship', value: 'INTERNSHIP' },
  { label: 'Internship + PPO', value: 'INTERNSHIP+PPO' },
  { label: 'Internship + PPO', value: 'INTERNSHIP_PPO' },
  { label: 'Appr.', value: 'APPRENTICESHIP' },
  { label: 'Gigs', value: 'GIGS' },
]

export const checkJobCategory = data => {
  let result = tabValues.find(item => item.value == data)
  return result?.label
}

export const getEducationLevelLabel = (level = '') => {
  switch (level) {
    case 'tenth':
      return '10th'
    case 'hsc':
      return '10th'
    case 'twelfth':
      return '12th'
    case 'sslc':
      return '12th'
    case 'puc':
      return 'Diploma'
    case 'p_g_diploma':
      return 'PG DIPLOMA'
    case 'diploma':
      return 'Diploma'
    case 'ug':
      return 'UG'
    case 'pg':
      return 'PG '
    case 'phd':
      return 'PD'
    case 'pd':
      return 'PD'
    default:
      break
  }
}
